<template>
    <v-dialog
        v-model="isOpen"
        persistent
        max-width="500"
    >
        <v-card>
            <v-card-title class="headline pb-10">
                {{$t('change_password')}}
            </v-card-title>
            <v-card-text>
                <v-text-field
                    :label="$t('attributes.password')"
                    outlined
                    v-model="password"
                    :type="password_show ? 'text' : 'password'"
                    :append-icon="password_show ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="password_show = !password_show"
                    v-validate="{required: true, min: 6, regex: /^[a-zA-Z0-9$@$!%*?&#^-_.+]+$/}"
                    :error-messages="errors.collect('password')"
                    data-vv-name="password"
                    required
                    ref="password"
                ></v-text-field>
                <v-text-field
                    :label="$t('password_confirm')"
                    outlined
                    v-model="confirmPassword"
                    :type="confirmPassword_show ? 'text' : 'password'"
                    :append-icon="confirmPassword_show ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="confirmPassword_show = !confirmPassword_show"
                    v-validate="'required|confirmed:password|alpha_num'"
                    :error-messages="errors.collect('confirmPassword')"
                    data-vv-name="confirmPassword"
                    required
                ></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close()">{{$t('close')}}</v-btn>
                <v-btn text color="primary" @click="save()">{{$t('save')}}</v-btn>
            </v-card-actions>
        </v-card>
        <overlay-loader :show="isLoading"></overlay-loader>
    </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
    $_veeValidate: {
        validator: 'new',
    },
    name: "NewPasswordModal",
    components: {
        OverlayLoader,
    },
    props: {
        email: {
            type: String,
            required: true
        },
        phone: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            password: '',
            confirmPassword: '',
            password_show: false,
            confirmPassword_show: false,
        };
    },
    computed: {
        isLoading() {
            return this.$store.getters.AUTH_IS_LOADING;
        },
        isOpen() {
            return this.$store.getters.IS_NEW_PASSWORD_MODAL_OPEN;
        }
    },
    methods: {
        close() {
            this.$store.dispatch('CHANGE_NEW_PASSWORD_MODAL', false);
        },
        save() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    const params = {
                        password: this.password,
                        email: this.email,
                        phone: this.phone.replace(/\D+/g, '')
                    };
                    this.$store.dispatch("CREATE_NEW_PASSWORD", params)
                        .then(() => {
                            this.$emit("close");
                            this.$router.push({ path: "/login" });
                            this.$toaster.success(this.$t("password_saved"));
                            this.$store.commit("SET_NEW_PASSWORD_WAS_CREATED", true);
                        })
                        .catch(() => {
                            this.$toaster.error(this.$t("server_error"));
                        });
                }
            });
        }
    }
};
</script>
